import React, { useState } from "react";
import Sidebar from "./Sidebar";
import { useLocation } from "react-router-dom";
import GlobalEdgeSearch, { showsEdgeSearch } from "./GlobalEdgeSearch";
import LicenseExpiryNotice from "./LicenseExpiryNotice";

export default function MainLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const { pathname } = useLocation();

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "var(--bg-app)" }}>
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <main
        style={{
          minHeight: "100vh",
          transition: "margin-left 0.3s ease",
          padding: "0 24px 24px",
          marginLeft: collapsed ? 60 : 240,
          backgroundColor: "var(--bg-app)",
          color: "var(--text-primary)",
        }}
      >
        {/* Edge search: only above the edge list, below the sidebar (z 1000), above the content */}
        {showsEdgeSearch(pathname) && (
        <div
          style={{
            position: "sticky",
            top: 0,
            zIndex: 500,
            margin: "0 -24px 16px",
            padding: "10px 24px",
            background: "var(--bg-app)",
            borderBottom: "1px solid var(--border)",
          }}
        >
          <GlobalEdgeSearch />
        </div>
        )}
        <LicenseExpiryNotice />
        {children}
      </main>
    </div>
  );
}
